import React, { useContext } from "react";
import {
  Box,
  Flex,
  VStack,
  Link,
  Image,
  Heading,
  Divider,
  Text,
} from "@chakra-ui/react";
import { ContentContext } from "../context/ContentContext";
import { ExternalLinkIcon } from "@chakra-ui/icons";

const Games = () => {
  const { games } = useContext(ContentContext);
  return (
    <Box bg="gray.700" color="teal.200" p={8}>
      <Heading as="h2">Latest Games</Heading>
      <Box p={4}>
        {games.map((data, index) => {
          return (
            <Box
              d="inline-block"
              key={index}
              maxW="sm"
              borderWidth="1px"
              borderRadius="lg"
              m={2}
            >
              <Image
                boxSize="200px"
                objectFit="cover"
                loading="lazy"
                src={data.image}
                alt={data.name}
              />
            </Box>
          );
        })}
      </Box>
      <Divider />
      <VStack mt={4} align="items-start" justify="content-between" w="75%">
        {games.map((data, index) => {
          return (
            <Flex justify="flex-start" align="items-center" key={index} p={4}>
              <Image
                w="200px"
                objectFit="cover"
                loading="lazy"
                mr={2}
                borderRadius="md"
                src={data.image}
                alt={data.title}
              />
              <Flex direction="column" p={4}>
                <Link href={`/movie/detail/${data.id}`}>
                  <Heading as="h3" size="lg" mb={4}>
                    {data.name}
                  </Heading>
                </Link>
                <Heading as="h4" size="md">
                  {data.platform}
                </Heading>
                <Text>Release year: {data.release}</Text>
                <Text>Single Player: {data.singlePlayer ? "Yes" : "No"}</Text>
                <Text>Multi Player: {data.multiplayer ? "Yes" : "No"}</Text>
                <Link
                  href={`https://www.youtube.com/results?search_query=${data.name} gameplay`}
                  mt={6}
                  isExternal
                >
                  Watch gameplay on Youtube <ExternalLinkIcon mx="2px" />
                </Link>
              </Flex>
            </Flex>
          );
        })}
      </VStack>
    </Box>
  );
};

export default Games;
